import { Component, OnInit } from '@angular/core';
import { Employee } from '../shared/models/employee';
import { IEntity } from '../shared/models/entity';
import { PpsUtilityService } from '../services/pps-utility.service';
import { subYears, addYears } from 'date-fns';
import { NgForm } from '@angular/forms';
import { AustraliaState } from '../shared/models/australia-state';
import * as _ from 'lodash-es';
import { Position } from '../shared/models/position';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { IRosterType } from '../shared/models/roster/roster-type';
import { IWorkArea } from '../shared/models/workarea';
import { IEmployer } from '../shared/models/employer';

@Component({
  selector: 'pps-employee-form',
  templateUrl: './employee-form.component.html',
  styleUrls: ['./employee-form.component.css']
})
export class EmployeeFormComponent implements OnInit {
  // value passed in from caller
  employee: Employee;
  states: AustraliaState[] = [];
  groups: IEntity[] = [];
  positions: Position[] = [];
  supervisors: Employee[] = [];
  rosterTypes: IRosterType[] = [];
  workAreas: IWorkArea[] = [];
  employers: IEmployer[] = [];
  maxDate: Date;
  yearRange: string = "";

  constructor(
    private dialogRef: DynamicDialogRef,
    private dlgConfig: DynamicDialogConfig,
    private _util: PpsUtilityService) {}

  ngOnInit(): void {
    this.states = this._util.getStates();
    this.maxDate = addYears(new Date(), 1);
    this.yearRange = `${2018}:${addYears(new Date(), 3).getFullYear()}`;

    this.setData(
      this.dlgConfig.data.employee,
      this.dlgConfig.data.employees,
      this.dlgConfig.data.workGroups,
      this.dlgConfig.data.positions,
      this.dlgConfig.data.rosterTypes,
      this.dlgConfig.data.workAreas,
      this.dlgConfig.data.employers,
    );    
  }

  setData(selectedEmployee: Employee, 
    employees: Employee[], 
    groups: IEntity[], 
    positions: Position[], 
    rosterTypes: IRosterType[], 
    workAreas: IWorkArea[],
    employers: IEmployer[]){
    this.employee = _.cloneDeep(selectedEmployee);
    
    if (this.employee.state != null){
      this.employee.state = this.employee.state.hasOwnProperty("code") ? this.employee.state : this.getStateObjectByCode(this.employee.state);
    }

    this.supervisors = employees
      .filter(emp => {
        return this._util.isSupervisorGroup(emp.workGroup.name) && emp.active;
      });

    if (selectedEmployee.supervisor && !selectedEmployee.supervisor.active){
      this.supervisors.push(selectedEmployee.supervisor);
    }

    this.supervisors = this.supervisors.sort((a, b) => {
      if (a.lastName > b.lastName){
        return 1;
      }

      if (a.lastName < b.lastName){
        return -1;
      }

      if (a.firstName > b.firstName){
        return 1;
      }

      if (a.firstName < b.firstName){
        return -1;
      }

      return 0;
    });

    this.groups = groups;
    this.positions = positions;
    this.rosterTypes = rosterTypes;
    this.workAreas = workAreas.filter(w=>w.active);
    this.employers = employers.sort((a, b) => a.employerName > b.employerName ? 1 : -1)
      .map(e => {
        return {id: e.id, employerName: e.active ? e.employerName : `(Inactive) ${e.employerName}`, active: e.active}
      });
  }

  save(form: NgForm){
    if (form.invalid){
      return false;
    }

    this.employee.state = this.employee.state ? this.employee.state.code : this.employee.state;
    this.dialogRef.close(this.employee);
  }

  setRosterTypeStartDate(rosterTypeDropdown){
    if (!rosterTypeDropdown.value){
      this.employee.rosterTypeStartDate = null;
    }

    if (rosterTypeDropdown.value && this.employee.rosterTypeStartDate === null){
      this.employee.rosterTypeStartDate = this.employee.hireDate;
    }
  }

  cancel(){
    //this.employee.state = this.employee.state.code;
    this.dialogRef.close();
  }

  isNewEmployee(){
    return this.employee === null || this.employee.id === 0;
  }

  getEmployeeName(employee: Employee): string{
    return this._util.getEmployeeName(employee);
  }
  
  private getStateObjectByCode(stateCode: string){
    return this.states.find(s => s.code === stateCode);
  }
}
